<template>
  <main class="main">
    <ol class="breadcrumb-trail__list">
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}` }"
          class="breadcrumb-trail__list--item__link"
        >
          TOP
        </router-link>
      </li>
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}question` }"
          class="breadcrumb-trail__list--item__link"
        >
          FAQ
        </router-link>
      </li>
    </ol>
    <h1 class="page-title">FAQ</h1>
    <p class="date-time">
      <time datetime="2021-03-05">{{ Question.dateTime[lang] }}</time>
    </p>
    <section
      class="faq"
      v-for="(item, itemIndex) in Question.items"
      :key="itemIndex"
    >
      <h2 class="subheading">{{ item.name[lang] }}</h2>
      <dl
        class="faq__list"
        v-for="(faq, faqIndex) in emptyRemoval(item.faqs)"
        :key="faqIndex"
      >
        <dt class="faq__list--question">{{ faq.question[lang] }}</dt>
        <dd class="faq__list--answer" v-html="faq.answer[lang]"></dd>
      </dl>
    </section>
  </main>
</template>

<script>
import Question from "../../../assets/constants/question/question.json";

export default {
  methods: {
    emptyRemoval: function (faqs) {
      return faqs.filter((faq) => faq.question[this.lang]);
    },
  },
  computed: {
    Question: function () {
      return Question;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "question",
};
</script>

<style scoped lang="scss">
$pageColor: #0093e6;
.main {
  text-align: center;
  .page-title {
    display: inline-block;
    margin: 96px 0 0 0;
    padding: 0;
    line-height: 1;
    font-size: 100px;
    font-weight: 900;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_faq.svg");
      margin-top: 8px;
    }
  }
  .date-time {
    margin: 124px 0 0 0;
    line-height: 1.5;
    text-align: right;
  }
  .faq {
    margin: 60px 0 0 0;
    text-align: left;
    &:first-of-type {
      margin: 24px 0 0 0;
    }
    .subheading {
      line-height: 1.33;
      font-size: 32px;
    }
    &__list {
      margin: 30px 0 0 0;
      padding: 0 0 30px 0;
      border-bottom: solid 1px #000;
      &--question {
        min-height: 50px;
        line-height: 1.5;
        padding: 16px 0 0 70px;
        position: relative;
        &::before {
          content: "Q";
          padding: 0 13px;
          border: solid 2px #000;
          border-radius: 50%;
          font-size: 32px;
          font-weight: bold;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      &--answer {
        min-height: 50px;
        margin: 10px 0 0 0;
        padding: 13px 0 0 70px;
        line-height: 1.5;
        white-space: pre-line;
        position: relative;
        &::before {
          content: "A";
          padding: 0 13px;
          border: solid 2px $pageColor;
          border-radius: 50%;
          font-size: 32px;
          font-weight: bold;
          color: $pageColor;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/faq/CommonQuestion.vue